<template>
  <router-view />
</template>

<script setup>

import AOS from 'aos';
import 'aos/dist/aos.css'; 

var inCMS = window.location.pathname.includes('/cms/');

console.log("MOUNTED Animate: inCMS", inCMS);
if(!inCMS){
    AOS.init();
} else {
    console.log("AOS disabled in CMS");
     AOS.init({
        disable: true
     });
}

</script>